import React from "react";
import { Box, Button } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const navigationItems = [
  { label: "Главное окно Portal", path: "/" },
  { label: "Premier", path: "/premier" },
  { label: "Предпросмотр", path: "/preview" },
  { label: "Подборки", path: "/collections" },
];

const PortalNavigation: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <Box
      component="nav"
      aria-label="Разделы Portal"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 1,
        mb: 2,
      }}
    >
      {navigationItems.map(({ label, path }) => {
        const isActive =
          pathname === path || (path !== "/" && pathname.startsWith(`${path}/`));

        return (
          <Button
            key={path}
            component={Link}
            to={path}
            variant="contained"
            disableElevation
            aria-current={isActive ? "page" : undefined}
            sx={{
              px: 2.5,
              py: 0.8,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 600,
              color: isActive ? "primary.contrastText" : "text.primary",
              bgcolor: isActive ? "primary.main" : "grey.300",
              "&:hover": {
                bgcolor: isActive ? "primary.dark" : "grey.400",
              },
            }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
};

export default PortalNavigation;
